export const environment = {
    production: true,
    // apiUrl: 'http://stg-api.goldbharat.com:3000/api/'
     apiUrl: 'https://api.goldbharat.com/api/'
    // apiUrl: 'http://localhost:3000/api/'
};
